import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

/**
 * Fetches one simulation's status: `{ simulationId, organizationId, dealId,
 * status, tickIntervalSeconds, lastActionOn, createdOn, stale, enabledTools }`.
 * An unknown id is a 404, surfaced through `errorCallback` with the backend
 * message.
 */
const getSimulationById = (simulationId, callback, errorCallback) => {
  return async (dispatch) => {
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const reqId = uuidv4();
        try {
          const response = await axios.get(
            `/ads/admin/simulations/${simulationId}`,
            {
              params: {
                'request-id': reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          if (response.status === 200) {
            if (typeof callback === 'function') callback(response?.data);
          } else {
            if (typeof errorCallback === 'function')
              errorCallback('Failed to fetch simulation');
          }
        } catch (e) {
          if (typeof errorCallback === 'function')
            errorCallback(
              e?.response?.data?.message ||
                (e?.response?.status === 404
                  ? `Simulation ${simulationId} does not exist`
                  : 'Failed to fetch simulation'),
            );
        }
        unsubscribe();
      });
    } catch (e) {
      if (typeof errorCallback === 'function')
        errorCallback('Failed to fetch simulation');
    }
  };
};

export default getSimulationById;
